const TAG = "LanguageManager";
class LanguageManager {
    fallback_language = "sv"
    currentLangCode = "sv";
    languages = [];
    appLanguages = {};

    _debug = false;

    constructor() {
        console.log(TAG, "Creating a LanguageManager Singleton!", {fallBack: this.fallback_language, langCode: this.currentLangCode, langs: this.languages});
    }

    setFallbackLanguage(fallback_language: string | undefined = undefined) {
        if(this._debug) console.log(TAG, "Setting Fallback Language", fallback_language);
        this.fallback_language = fallback_language || this.fallback_language;
    }
    setCurrentLangCode(langCode: string | undefined = undefined) {
        if(this._debug) console.log(TAG, "Setting current Language", langCode);
        this.currentLangCode = langCode || this.currentLangCode;
    }
    setLanguages(languages = []){
        if(this._debug) console.log(TAG, "Setting list of available languages", languages);
        this.languages = languages;
    }
    setAppLanguages(appLanguages: any = {}) {
        // if(this._debug) console.log(TAG, "Setting list of appLanguages", appLanguages);
        this.appLanguages = appLanguages;
    }

    getLocalizedItem(text, fallbackToDefault= false) {
        if (!text) { return ""; }
        const clc = this.currentLangCode;
        if (text[clc]) {
            if(this._debug) console.log(TAG, "Text exists in CLC: ", text[clc]);
            return text[clc];
        } else if(text['x']) {
            return text['x'];
        }
        else if (fallbackToDefault && text[this.fallback_language]) { return text[this.fallback_language]; }
        else { return ""; }
    }

    getLocalizedAppText(key, fallbackToDefault = true) {
        // console.log(TAG, "Looking up ", key);
        const getFallback = (key) => {
            const fblang = this.appLanguages[this.fallback_language];
            if (fblang) {
                // The fallback language exists
                if (fblang.WebAppText) {
                    // The language has WebAppTexts...
                    if (fblang.WebAppText[key]) {
                        // The text was found in a fallback lang, return it
                        return fblang.WebAppText[key];
                    } else {
                        // console.error(TAG, "String ", key, " did not exist in fallback language");
                        // console.error(TAG, "Find any and first lang that matches to show something");
                        const languages = this.appLanguages;
                        for (let l in languages) {
                            if (languages.hasOwnProperty(l)) {
                                const lang = languages[l];
                                if (lang.WebAppText && lang.WebAppText[key]) {
                                    // console.log(TAG, "Found ", key, "in ", l);
                                    return lang.WebAppText[key]
                                }
                            }
                        }
                    }
                }
            }
        }
        const clc = this.currentLangCode;
        const curlang = this.appLanguages[clc];
        if (curlang) {
            // This language exists at all
            if (curlang.WebAppText) {
                if (curlang.WebAppText[key]) {
                    console.log(TAG, "Returning", curlang.WebAppText[key]);
                    return curlang.WebAppText[key];
                } else {
                    console.error(TAG, "String ", key, " did not exist in current language");
                    return getFallback(key);
                }
            }
        } else if(fallbackToDefault) {
            return getFallback(key);
        } else {
            console.error(TAG, "Neither language or fallback language exists in Firebase data");
        }
        // If nothing else just return empty string
        console.log("Nothing found return empty string");
        return "";
    }
}
const languageManager = new LanguageManager();
export default languageManager;
